/*
 * @providesModule Background
 */

import React from 'react';
import SkillzStyle from 'SkillzStyle';

import {
  View,
  ViewStyle,
} from 'react-native';

type Props = {
  style?: ViewStyle,
  children?: React.ReactNode;
};

type State = {};

export default class Background extends React.Component<Props, State> {
  backgroundImage: string;

  constructor(props: Props) {
    super(props);

    this.backgroundImage = '';

    if (SkillzStyle.images.backgroundImage) {
      this.backgroundImage = SkillzStyle.images.backgroundImage;
    }
  }

  render(): React.ReactElement {
    return (
      <View style={[{flexGrow: 1, backgroundColor: 'transparent'}, this.props.style]}>
        {[this.props.children]}
      </View>
    );
  }
}
